// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-prestige -> rr-living-prestige -> summer-trace-at-gulf-shores
// Generated: 2026-11-03T18:20:55.160Z
// Counts: 1 design, 34 content, 5 slot group, 1 collection binding, 6 section, 1 style

export const designOverrides = {
  "design.block:multihub-lead-form.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "header.interactive_map_show_if_exists": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "apartmentsyncsection.block": {
    "overrideType": "VALUE",
    "customValue": "realpage-oll",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.heading": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>The fees below apply to this community. Amounts shown are the most current figures on file and are subject to change. A \"—\" indicates that a fee does not apply at this property. Please note that not every fee listed applies to every resident. Some fees are optional and only apply if you choose certain services or amenities, while others apply only in specific situations, such as application screening results, lease options, late payments, or lease policy violations. Please contact the leasing office for full details and to discuss which fees may apply to your specific situation.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "header.preferred_employer_title": {
    "overrideType": "VALUE",
    "customValue": "Preferred Employer Benefits",
    "generatedValue": null,
    "mappedField": null
  },
  "interioramenitieslist.footnote": {
    "overrideType": "VALUE",
    "customValue": "<p>*Available in select apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interioramenitieslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Apartment Features</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "petscallout.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_policy_description"
  },
  "scheduletourform.form.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.administrative_fee": {
    "overrideType": "VALUE",
    "customValue": "$175",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.application_fee": {
    "overrideType": "VALUE",
    "customValue": "$75",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.building_liability_captive": {
    "overrideType": "VALUE",
    "customValue": "$15",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.credit_builder": {
    "overrideType": "VALUE",
    "customValue": "$8.95",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.early_termination_fee": {
    "overrideType": "VALUE",
    "customValue": "60-day notice plus 1 month’s base rent",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.intra_community_transfer_fee": {
    "overrideType": "VALUE",
    "customValue": "$300",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.late_fee": {
    "overrideType": "VALUE",
    "customValue": "10% of base rent",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.month_to_month_fee": {
    "overrideType": "VALUE",
    "customValue": "$500",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.move_out_cleaning_fee": {
    "overrideType": "VALUE",
    "customValue": "$15 - $350 (varies by unit)",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.parking_garage": {
    "overrideType": "VALUE",
    "customValue": "$100",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pest_control_fee": {
    "overrideType": "VALUE",
    "customValue": "$5",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pet_fee": {
    "overrideType": "VALUE",
    "customValue": "$400 - 1 month of rent Depending on FICO score",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pet_rent": {
    "overrideType": "VALUE",
    "customValue": "$25-$40",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.resident_services_total": {
    "overrideType": "VALUE",
    "customValue": "$20",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.risk_fee": {
    "overrideType": "VALUE",
    "customValue": "300+",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.trash_non_valet": {
    "overrideType": "VALUE",
    "customValue": "$10",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.washer_dryer_fee": {
    "overrideType": "VALUE",
    "customValue": "$35",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "petscallout.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019e85db-45c6-7570-8b98-f085354e1af6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman holding a dog indoors."
      }
    }
  },
  "floor-plans-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/fee-information"
      },
      "label": {
        "type": "VALUE",
        "customValue": "View Fee Information"
      }
    }
  },
  "specialofferbanner.specials_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": ""
      },
      "label": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "layoutoverview.card_image_2": {
    "sourceIndex": 3,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "interioramenitieslist.photos": {
    "limit": null,
    "hiddenIds": [
      "custom_8ae21af6-235f-4940-b7cb-50ad4c4597a0"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      7
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.block:realpage-oll": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  }
};
